// @flow

import DataLayerEvent from './DataLayerEvent';
import EventNames from '../../../../constants/DataLayer/EventNames';

export default class SignUp extends DataLayerEvent {
  /**
     * @inheritDoc
     */
  dispatch(): void {
    super.dispatch();
    this.push({
      event: EventNames.SIGN_UP,
      ecommerce: {
        method: 'email'
      }
    });
  }
}
